import { render, staticRenderFns } from "./ChampionshipEventCard.vue?vue&type=template&id=60167a3d&scoped=true&"
import script from "./ChampionshipEventCard.vue?vue&type=script&lang=js&"
export * from "./ChampionshipEventCard.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipEventCard.vue?vue&type=style&index=0&id=60167a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60167a3d",
  null
  
)

export default component.exports